import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import AdminLogin from './components/AdminLogin/AdminLogin';
import AdminPanel from './components/AdminPanel/AdminPanel';
import ResetPassword from './components/AdminLogin/ResetPassword';


import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const adminUser = localStorage.getItem('adminUser');
    if (token && adminUser) setIsAuthenticated(true);
    setLoading(false);
  }, []);

  const handleLogin = () => setIsAuthenticated(true);
  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated ? <Navigate to="/admin/userdetails" /> : <AdminLogin onLogin={handleLogin} />
        }
      />
      <Route
        path="/admin/*"
        element={
          isAuthenticated ? <AdminPanel onLogout={handleLogout} /> : <Navigate to="/" />
        }
      />
      <Route path="/admin/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

export default App;
